import axios from "axios";
import ElementUI from "element-ui";

axios.defaults.baseURL = "http://120.24.147.42:8081"

const request = axios.create({
    timeout:5000,
    headers:{
        'Content-Type':"application/json; charset=utf-8"
    }
})

request.interceptors.request.use(config => {
    return config
})

request.interceptors.response.use(response => {
    let res = response.data
    if(res.code === 200) {
        return response
    }else{
        ElementUI.Message.error(!res.msg? '系统异常' : res.msg)
        return Promise.reject(response.data.msg)
    }
}, error => {
    if(error.response.data) {
        error.message = error.message.data.msg
    }
    ElementUI.Message.error(error.message,{duration:3000})
    return Promise.reject(error)
})

export default request
